import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('tiger-zodiac', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 44V15C6 13.5 7 9.8 11 7L8.5 4C10.1667 4 14.1 4.6 16.5 7C20.6667 6.66667 30 9 26.5 15C25.6101 16.3349 24 17 21 17",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 24C23 24 31 29 31 38C31 40 32 42.8834 36.1343 42.4015C39 42.0674 41.6269 40.0523 43 35.8759",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 44.0003C17 40.0001 19 35.0003 27 35.0003L30 35.0003",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});